import { Request, BaseApiUrl } from "./api";

// 列表
export const getMatReceiveListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatReceive/Get`, { params: params });
};

//新增
export const addMatReceive = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatReceive/Post`, params);
};

//删除
export const removeMatReceive = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatReceive/Delete`, params);
};

//获取详情
export const getMatReceiveDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatReceive/Detail`, { params: params });
};
//基础信息
export const getMatReceiveBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatReceive/GetMatReceiveBaseData` );
};
